import type { ChangeEventHandler, ReactNode } from "react";
import { styled } from "styled-components";

import { CrossIcon, Spinner } from "common/components";
import { PermissionOption } from "domains/createShareSettings/components/PermissionOption";

const StyledRow = styled.div`
  display: flex;
  align-items: center;
`;

const StyledFirstRow = styled(StyledRow)`
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StyledOuterRow = styled(StyledRow)`
  justify-content: space-between;
  margin-bottom: 1rem;
  &:last-child {
    margin-bottom: 0;
  }
`;

const StyledTitleContainer = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  margin: 0 10px;
`;

const StyledTitle = styled.p`
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.fillPrimary};
  margin: 0;
`;

const StyledSubtitle = styled.p`
  font-size: 0.9rem;
  color: #bbb;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
`;

const StyledCross = styled(CrossIcon)`
  width: 15px;
  height: 15px;
  color: #bbb;
  cursor: pointer;
`;

const StyledSpinner = styled(Spinner)`
  width: 15px;
  height: 15px;
  color: #bbb;
`;

const StyledPermissionOption = styled.div`
  margin-right: 10px;
`;

type AccessListItemProps = {
  caption?: string;
  editablePermission?: boolean;
  icon: ReactNode;
  isPermissionChanging?: boolean;
  onPermissionChange?: ChangeEventHandler<HTMLSelectElement>;
  permission: string;
  removeAction?: () => void;
  removePending?: boolean;
  title: string;
};

export const AccessListItem = ({
  icon,
  title,
  caption,
  permission,
  onPermissionChange,
  isPermissionChanging,
  removePending,
  removeAction,
  editablePermission = true,
}: AccessListItemProps) => (
  <StyledOuterRow>
    <StyledFirstRow>
      {icon}
      <StyledTitleContainer>
        <StyledTitle>{title}</StyledTitle>
        <StyledSubtitle>{caption}</StyledSubtitle>
      </StyledTitleContainer>
    </StyledFirstRow>
    <StyledRow>
      {editablePermission && onPermissionChange && (
        <StyledPermissionOption>
          <PermissionOption
            defaultValue={permission}
            isEditable={permission !== "owner"}
            isPending={isPermissionChanging}
            onChange={onPermissionChange}
          />
        </StyledPermissionOption>
      )}
      {removePending ? <StyledSpinner /> : <StyledCross opacity={!removeAction ? 0 : 1} onClick={removeAction} />}
    </StyledRow>
  </StyledOuterRow>
);
